import React from "react";
import classes from "./ContactUs.module.css";

import Button from "../../../../UI/Button/Button";

const ContactUs = (props) => {
  return (
    <div className={classes.container}>
      <div className={classes.item}>
        <div className={classes.label}>Full Name:</div>
        <input className={classes.textField} />
      </div>
      <div className={classes.item}>
        <div className={classes.label}>Email:</div>
        <input className={classes.textField} />
      </div>
      <div className={classes.msgContainer}>
        <div className={classes.label}>Message:</div>
        <textarea className={classes.msg} rows={10}></textarea>
        <div className={classes.rowCenter}>
        <Button width={150} height={50}>
          Submit
        </Button>
        </div>
      </div>
    </div>
  );
};
export default ContactUs;
